import React, { useState } from "react";
import styled from "styled-components";
import logoSvg from "../images/mlknaggsLogo.png";

const Nav = styled.nav`
  padding: 0 20px;
  min-height: 9vh;
  background: #1c2022;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

const Logo = styled.h1`
  font-size: 25px;
  color: white;
`;

const Menu = styled.ul`
  list-style: none;
  display: flex;
  li {
    margin: 0px 15px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const Item = styled.li``;

const Link = styled.a`
  color: white;
  text-decoration: none;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

const NavIcon = styled.button`
  background: none;
  cursor: pointer;
  border: none;
  outline: none;
  @media (min-width: 769px) {
    display: none;
  }
`;

interface LineProps {
  open: boolean;
}

const Line = styled.span<LineProps>`
  display: block;
  border-radius: 50px;
  width: 25px;
  height: 3px;
  margin: 5px;
  background-color: #fff;
  transition: width 0.4s ease-in-out;
  :nth-child(2) {
    width: ${(props) => (props.open ? "40%" : "70%")};
  }
`;

const Overlay = styled.div.attrs<LineProps>((props) => ({
  style: { height: props.open ? "91vh" : "0" },
}))<LineProps>`
  position: absolute;
  width: 100vw;
  background: #1c2022;
  transition: height 0.4s ease-in-out;
  @media (min-width: 769px) {
    display: none;
  }
`;

interface OverlayMenuProps {
  open: boolean;
}

const OverlayMenu = styled.ul<OverlayMenuProps>`
  list-style: none;
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  li {
    opacity: ${(props) => (props.open ? 1 : 0)};
    font-size: 25px;
    margin: 50px 0px;
    transition: opacity 0.4s ease-in-out;
  }
`;

// New styled component for the centered icon container
const CenteredIconContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface ResponsiveAppBarProps {
  onNavClick: (id: string) => void;
}

const ResponsiveAppBar: React.FC<ResponsiveAppBarProps> = ({ onNavClick }) => {
  const [toggle, toggleNav] = useState(false);

  const handleNavClick = (id: string) => {
    onNavClick(id);
    toggleNav(false); // Close mobile menu after clicking
  };

  return (
    <>
      <Nav style={{ zIndex: 1000 }}>
        <Logo>M.L. Knaggs</Logo>
       
        {/* Center SVG Icon */}
        <CenteredIconContainer>
          <img src={logoSvg} alt="M.L. Knaggs Logo" width="80" height="80" />
        </CenteredIconContainer>
       
        <Menu>
          <Item>
            <Link onClick={() => handleNavClick('home')}>
              HOME
            </Link>
          </Item>
          <Item>
            <Link onClick={() => handleNavClick('books')}>
              BOOKS
            </Link>
          </Item>
          <Item>
            <Link href="/universe">
              UNIVERSE
            </Link>
          </Item>
          <Item>
            <Link onClick={() => handleNavClick('contact-section')}>
              CONTACT
            </Link>
          </Item>
          <Item>
            <Link href="/about">
              ABOUT
            </Link>
          </Item>
        </Menu>
        <NavIcon onClick={() => toggleNav(!toggle)}>
          <Line open={toggle} />
          <Line open={toggle} />
          <Line open={toggle} />
        </NavIcon>
      </Nav>
      <Overlay open={toggle} style={{ zIndex: 1000 }}>
        <OverlayMenu open={toggle}>
          <Item>
            <Link onClick={() => handleNavClick('home')}>
              HOME
            </Link>
          </Item>
          <Item>
            <Link onClick={() => handleNavClick('books-section')}>
              BOOKS
            </Link>
          </Item>
          <Item>
            <Link href="/universe">
              UNIVERSE
            </Link>
          </Item>
          <Item>
            <Link onClick={() => handleNavClick('contact-section')}>
              CONTACT
            </Link>
          </Item>
          <Item>
            <Link href="/about">
              ABOUT
            </Link>
          </Item>
        </OverlayMenu>
      </Overlay>
    </>
  );
};

export default ResponsiveAppBar;